import { Layout, Row, Typography } from "antd";
import { useTranslation } from "react-i18next";
import ArrowLeftIconComponent from "../../../components/ArrowLeftIconComponent";
import TrackingLinksComponent from "../../../components/TrackingLink/TrackingLinksComponent/TrackingLinksComponent";
import "./index.less";

const CreatorTrackingLinksPage = () => {
  const { t } = useTranslation();

  return (
    <Layout className="gradient-background-blue-settings">
      <Layout.Content className="content CreatorTrackingLinksWrapper gradient-background-blue-settings">
        <Row className="w-full relative justify-content-center header-title-container-70">
          <ArrowLeftIconComponent top={8} navigateTo="/common/setting" />
          <Typography.Text className="header-title-black-30">{t("tracking-links")}</Typography.Text>
        </Row>

        <div>
          <TrackingLinksComponent />
        </div>
      </Layout.Content>
    </Layout>
  );
};

export default CreatorTrackingLinksPage;
